import React from "react";
import { Link } from "react-router-dom";
import { BRAND_COLOR } from "../../common/constants";
import Navbar from "./nav_bar/Navbar";
import Footer from "./footer/Footer";
import HowDoesItWork from "./HowDoesItWork";

const HowItWorksPage = () => {
 return (
 <>
 <Navbar />
 <div style={{ marginTop: "80px" }}>
 <HowDoesItWork />
 
 {/* Additional Content Section */}
 <section style={{
 padding: "60px 20px",
 backgroundColor: "white",
 textAlign: "center"
 }}>
 <div style={{ maxWidth: "800px", margin: "0 auto" }}>
 <h3 style={{
 fontSize: "28px",
 color: BRAND_COLOR,
 marginBottom: "20px"
 }}>
 Ready to Start Speaking?
 </h3>
 <p style={{
 fontSize: "18px",
 color: "#555",
 lineHeight: 1.6,
 marginBottom: "30px"
 }}>
 Join thousands of learners who have improved their English speaking confidence 
 with our interactive sessions. Sign up and get free sessions to get started!
 </p>
 
 <div style={{
 display: "flex",
 justifyContent: "center",
 gap: "20px",
 flexWrap: "wrap"
 }}>
 <Link
 to="/register"
 style={{
 backgroundColor: BRAND_COLOR,
 color: "white",
 padding: "14px 28px",
 borderRadius: "8px",
 textDecoration: "none",
 fontSize: "16px",
 fontWeight: "600",
 transition: "background-color 0.3s ease"
 }}
 >
 Sign Up Now - Free!
 </Link>
 
 <Link
 to="/timetable"
 style={{
 backgroundColor: "transparent",
 color: BRAND_COLOR,
 padding: "14px 28px",
 border: `2px solid ${BRAND_COLOR}`,
 borderRadius: "8px",
 textDecoration: "none",
 fontSize: "16px",
 fontWeight: "600",
 transition: "all 0.3s ease"
 }}
 >
 View Schedule
 </Link>
 </div>
 </div>
 </section>
 </div>
 <Footer />
 </>
 );
};

export default HowItWorksPage;